module.exports = __webpack_public_path__ + "img/offboarding-user.64fb7e75.svg";